<template>
  <div>
    <div id="polygon-map"></div>
    <div>
      名稱：
      <el-input
        type="text"
        min="0"
        style="width: 150px"
        v-model="name"
      ></el-input>
      <el-button type="primary" size="small" @click="save()" title="暫存並返回"
        >暫存並返回
      </el-button>
      <el-button type="danger" size="small" @click="clean()" title="清空"
        >清空
      </el-button>
    </div>
  </div>
</template>

<script>
import GoogleMapsLoader from "google-maps";
import axios from "axios";

export default {
  data() {
    return {
      allPolygons: [],
      polygonPaths: [],
      name: "",
      drawingManager: null,
      google: null,
      map: null
    };
  },
  computed: {
    user: function() {
      return this.$store.getters.user;
    }
  },
  methods: {
    save() {
      window.opener.parent.postMessage({
        name: this.name,
        allPolygons: this.allPolygons,
        index: this.$route.query.index,
        ruleId: this.$route.query.rule_id
      });
      self.close();
    },
    clean() {
      console.log("clean go");

      // TODO: clean polygons
      let self = this;
      self.allPolygons = [];
      for (let p of this.polygonPaths) {
        p.setMap(null);
      }
      this.polygonPaths = [];
      this.initDrawing();
    },
    initDrawing() {
      let self = this;
      let google = self.google;
      let map = self.map;
      self.drawingManager = new google.maps.drawing.DrawingManager({
        // drawingMode: google.maps.drawing.OverlayType.MARKER,
        // drawingMode: google.maps.drawing.OverlayType.CIRCLE,
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [
            // google.maps.drawing.OverlayType.MARKER,
            // google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON
            // google.maps.drawing.OverlayType.POLYLINE,
            // google.maps.drawing.OverlayType.RECTANGLE,
          ]
        },
        // markerOptions: {
        //   icon:
        //     "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
        // },
        circleOptions: {
          fillColor: "#fcba03",
          fillOpacity: 0.5,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        },
        polygonOptions: {
          fillColor: "#fcba03",
          fillOpacity: 0.5,
          strokeWeight: 5,
          clickable: false,
          editable: true,
          zIndex: 1
        }
      });

      // 畫完polygons, 回傳座標
      // let allPolygons = [];

      function showArrays(polygon) {
        let polygonPaths = [];
        // Since this polygon has only one path, we can call getPath() to return the
        // MVCArray of LatLngs.
        // const polygon = this;
        const vertices = polygon.getPath();

        // Iterate over the vertices.
        for (let i = 0; i < vertices.getLength(); i++) {
          const xy = vertices.getAt(i);
          // console.log("<br>" + "Coordinate " + i + ":<br>" + xy.lat() + "," + xy.lng());
          polygonPaths.push({
            x: xy.lat(),
            y: xy.lng()
          });
        }
        // 要close多邊形
        const xyo = vertices.getAt(0);
        polygonPaths.push({
          x: xyo.lat(),
          y: xyo.lng()
        });
        // console.log(JSON.stringify(polygonPaths));
        self.allPolygons.push(polygonPaths);
      }

      google.maps.event.addListener(
        self.drawingManager,
        "polygoncomplete",
        function(polygon) {
          // var paths = polygon.getPaths();
          showArrays(polygon);
        }
      );

      self.drawingManager.setMap(map);
    },
    getPolygons() {
      let self = this;
      if (this.$route.query.rule_id) {
        // 資料格式範例
        return axios
          .get(
            `${process.env.VUE_APP_APIHOST}/${this.user.type}/shops/${
              this.$route.query.shop_id
            }/logistic-rules/${this.$route.query.rule_id}/polygons`
          )
          .then(response => {
            console.log(response.data);
            if (response && response.data) {
              for (let data of response.data) {
                if (data.polygons) {
                  try {
                    data.polygons = JSON.parse(data.polygons);
                    console.log("after");
                  } catch (e) {
                    console.log("parse faile? ", e);
                  }
                }
              }
            }
            return response.data;
          });
      } else {
        return new Promise((resolve, reject) => {
          resolve([]);
        });
      }
    }
  },
  mounted() {
    let self = this;
    this.getPolygons().then(polygons => {
      console.log(JSON.stringify(polygons));
      GoogleMapsLoader.KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
      GoogleMapsLoader.LIBRARIES = ["drawing"];
      let center = { lat: 25.0593739, lng: 121.5445842 }; // default
      if (polygons && polygons.length) {
        let cenPoint1 = polygons[0].polygons.coordinates[0][0];
        console.log("center ", cenPoint1);
        center = { lat: cenPoint1[0], lng: cenPoint1[1] };
      }
      GoogleMapsLoader.load(function(google) {
        self.google = google;

        var options = {
          // center: { lat: 25.0593739, lng: 121.5445842 }, // 如果有畫了多邊形，應該要根據這個拉到中心
          center: center,
          zoom: 16
        };

        var map = new google.maps.Map(
          document.getElementById("polygon-map"),
          options
        );
        self.map = map;

        // 如果有現有的，就要清空才能畫
        if (polygons && polygons.length) {
          // 如果有既有的多邊形，可以畫出來？
          // 建立多邊形
          for (let i = 0; i < polygons.length; ++i) {
            try {
              let path = [];
              for (let c of polygons[i].polygons.coordinates[0]) {
                path.push({ lat: c[0], lng: c[1] });
              }
              let polygonPath = new google.maps.Polygon({
                path: path,
                strokeColor: "#bA0000",
                strokeOpacity: 0.5,
                strokeWeight: 5,
                strokePosition: google.maps.StrokePosition.CENTER,
                fillColor: "#f00",
                fillOpacity: 0.35,
                editable: false,
                // draggable: true, // 可以拖動位置
                map: map
              });
              self.polygonPaths.push(polygonPath);
            } catch (e) {}
          }
        } else {
          // 繪圖相關
          self.initDrawing(google);
        }
      });
    });
  }
};
</script>

<style>
#polygon-map {
  height: 600px;
  width: 100%;
}
</style>
